import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { Snackbar } from '@interstate/components/Snackbar';

import { useBalloonPaymentField } from './hooks/useBalloonPaymentField';

const BalloonPaymentField = () => {
    const { label, inputProps, fallbackSnackbarProps } = useBalloonPaymentField();

    return (
        <>
            <NumericInput {...inputProps} label={label} />
            <Snackbar {...fallbackSnackbarProps} />
        </>
    );
};

export default BalloonPaymentField;
